import React from 'react';

export const Layout = ({ children }) => {

    
  return (
    <section id="layout__container">
      {children}
    </section>
  );
};
